<template>
    <div>
        <v-app>
            <v-app-bar
                style="
                    background: linear-gradient(90deg, #f9fdfb 17%, #e1e9f2);
                    color: black;
                "
                dark
                prominent
            >
                <v-app-bar-title>
                    <img
                        src="/images/D3_Connectv2.png"
                        alt="logo"
                        style="max-height: 35px"
                    />
                </v-app-bar-title>
            </v-app-bar>

            <v-main class="bg-grey-lighten-2">
                <slot />
            </v-main>
        </v-app>
    </div>
</template>

<script>
export default {
    name: "GuestLayout",
};
</script>
<style scoped></style>
